import React from 'react'
import Head from '../../../../layout/head/Head'
import Content from '../../../../layout/content/Content'
import SectionAbout from './DomainServiceComponents/SectionAbout'
import SectionService from './DomainServiceComponents/SectionService'
import OurServices from './DomainServiceComponents/OurServices'
import Contact from '../../components/Contact'
import Testimonial from '../components/Testimonial'
import GenericHero from '../components/GenericHero'
import { Icon } from '../../../../components/Component'
import heroimg from '../../../../images/axiom_img/Domain Management.png';


const Domainservice = () => {
  return (
    <React.Fragment>
      <Head title="Axiom | Domain Registration Service" />
      <Content>
        {/* <SectionHero /> */}
        <GenericHero
          breadcrumbs={
            <>
              SERVICES <Icon name={'chevron-right'} />Web Infrastructure & Management<Icon name={'chevron-right'} /> Domain Registration & Management
            </>
          }
          title="Enterprise-Grade domain management solutions"
          description="Dedicated account management & proactive security monitoring"
          buttonText="Contact Now"
          buttonLink="/contact"
          heroImage={heroimg} />
        <SectionAbout />
        <SectionService />
        <OurServices />
        <Contact />
        <Testimonial />
      </Content>
    </React.Fragment>
  )
}

export default Domainservice
